<template>
  <div>
    <el-dialog
      class="form-modal"
      :visible.sync="visible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
      @open="populateFields"
      v-loading="loading"
    >
      <div class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">
            {{ context }} Campaign {{ form.campaignId }}
          </h1>
          <div class="modal-actions col-2">
            <el-button
              type="primary"
              @click="handleSubmit"
              v-if="form.status !== 'EXPIRED'"
              >{{ context === "Edit" ? "Save" : context }}</el-button
            >
            <el-button type="default" @click="handleClose">Cancel</el-button>
          </div>
        </div>
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <div v-if="this.context === 'Edit'" class="container-campaign-cards">
          <el-row class="mt-0" :gutter="30">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :span="16">
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
              >
                <div class="widget-header ph-20 pt-10">
                  <div class="flex justify-center align-center">
                    <div class="widget-info box grow text-truncate">
                      <h2
                        class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center"
                      >
                        <v-svg class="black-text" sprite="message"></v-svg>
                        <span class="black-text pl-4">Campaign Details</span>
                      </h2>
                    </div>
                  </div>
                  <div class="system-status">
                    <div class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Register Date</span>
                        <span class="black-text">{{ form.registerDate }}</span>
                      </div>
                    </div>
                    <div class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Use Case</span>
                        <span class="black-text">{{ form.usecase }}</span>
                      </div>
                    </div>
                    <div class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Share Date</span>
                        <span class="black-text">{{
                          campaignStatus.statusDate
                            ? timeFormatter(campaignStatus.statusDate)
                            : "N/A"
                        }}</span>
                      </div>
                    </div>
                    <div class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Sharing Status</span>
                        <span class="black-text">{{
                          campaignStatus.sharingStatus
                            ? campaignStatus.sharingStatus
                            : "N/A"
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="campaignStatus.sharingStatus === 'DECLINED'"
                  class="nudge-button"
                >
                  <el-button @click="nudgeCNP">
                    <div class="nudge">
                      <i class="el-icon-error voxo-dark-red" />
                      <span>Nudge Campaign</span>
                    </div>
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Description</h2>
            <div class="flex items-center">
              <p class="black-text">{{ form.description.length }} / 4096</p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    A description of what the campaign will be used for.
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item prop="description">
            <el-input
              v-model="form.description"
              type="textarea"
              minlength="40"
              maxlength="4096"
              :rows="2"
              placeholder="Campaign Description"
            >
            </el-input>
          </el-form-item>
        </div>

        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Message Flow</h2>
            <div class="flex items-center">
              <p class="black-text">{{ form.messageFlow.length }} / 2048</p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    This field should describe how a consumer opts-in to the
                    campaign, therefore giving consent to the sender to receive
                    their messages. The call-to-action must be explicitly clear
                    and inform the consumer of the nature of the program. If
                    multiple opt-in methods can be used for the same campaign,
                    you must list them all.
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item prop="messageFlow">
            <el-input
              v-model="form.messageFlow"
              type="textarea"
              minlength="40"
              maxlength="2048"
              :rows="2"
              placeholder="Call-to-Action / Message Flow"
            >
            </el-input>
          </el-form-item>
        </div>

        <h2 class="form-section-header" style="margin-top: 40px">
          Sample Messages
        </h2>
        <div v-for="(input, index) in inputFields" :key="index">
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Sample {{ index + 1 }}</h2>
            <div class="flex items-center">
              <p class="black-text">{{ form[input.key].length }} / 1024</p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    A sample message ex. This is a test. Reply STOP to opt out.
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item :prop="input.key">
            <el-input
              v-model="form[input.key]"
              type="textarea"
              minlength="20"
              maxlength="1024"
              :rows="2"
              placeholder="Sample Message"
            >
            </el-input>
          </el-form-item>
        </div>

        <div class="inline-form-group">
          <el-button
            class="mv-24"
            type="default"
            icon="el-icon-circle-plus-outline"
            @click="addInputField"
            :disabled="inputFields.length >= 5"
          >
            Add Sample Message
          </el-button>
        </div>

        <h2 class="form-section-header">Campaign and Content Attributes</h2>
        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Opt-in Keywords</h2>
            <div class="flex items-center">
              <p class="black-text">
                {{ form.optinKeywords.join(" ").length }} / 255
              </p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    A keyword consumers can text to opt-in. ex. YES, JOIN
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item prop="optinKeywords">
            <el-select
              v-model="form.optinKeywords"
              multiple
              filterable
              allow-create
              placeholder="Select Opt-in Keywords"
            >
              <el-option
                v-for="keyword in optinKeywords"
                :key="keyword"
                :label="keyword"
                :value="keyword"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Opt-in Message</h2>
            <div class="flex items-center">
              <p class="black-text">{{ form.optinMessage.length }} / 320</p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    If consumers can text in a keyword, the response should
                    include the Brand name, confirmation of opt-in enrollment to
                    a recurring message campaign, how to get help, and clear
                    description of how to opt-out. ex. Thanks for subscribing.
                    Reply STOP at any time to unsubscribe. Reply HELP to get
                    assistance.
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item class="custom-label" prop="optinMessage">
            <el-input
              v-model="form.optinMessage"
              type="textarea"
              minlength="20"
              maxlength="320"
              :rows="2"
              placeholder="Type Opt-in Message here"
            >
            </el-input>
          </el-form-item>
        </div>

        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Opt-out Keywords</h2>
            <div class="flex items-center">
              <p class="black-text">
                {{ form.optoutKeywords.join(" ").length }} / 255
              </p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    A keyword consumers can text to opt-out. ex. STOP
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item prop="optoutKeywords">
            <el-select
              v-model="form.optoutKeywords"
              multiple
              filterable
              allow-create
              placeholder="Select Opt-out Keywords"
            >
              <el-option
                v-for="keyword in optoutKeywords"
                :key="keyword"
                :label="keyword"
                :value="keyword"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Opt-out Message</h2>
            <div class="flex items-center">
              <p class="black-text">{{ form.optoutMessage.length }} / 320</p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    The response to the STOP keyword may include the Brand name
                    but should include an acknowledgement of opt-out request and
                    confirmation that no further messages will be sent. ex. You
                    have successfully unsubscribed. Reply JOIN any time to
                    subscribe again.
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item prop="optoutMessage">
            <el-input
              v-model="form.optoutMessage"
              type="textarea"
              minlength="20"
              maxlength="320"
              :rows="2"
              placeholder="Type Opt-out Message here"
            >
            </el-input>
          </el-form-item>
        </div>

        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Help Keywords</h2>
            <div class="flex items-center">
              <p class="black-text">
                {{ form.helpKeywords.join(" ").length }} / 255
              </p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    A keyword consumers use to get help or more information. ex.
                    HELP
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item prop="helpKeywords">
            <el-select
              v-model="form.helpKeywords"
              :multiple="true"
              :filterable="true"
              :allow-create="true"
              placeholder="Select Help Keywords"
            >
              <el-option
                v-for="keyword in helpKeywords"
                :key="keyword"
                :label="keyword"
                :value="keyword"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div>
          <div class="container" style="max-width: 600px">
            <h2 class="black-text">Help Message</h2>
            <div class="flex items-center">
              <p class="black-text">{{ form.helpMessage.length }} / 320</p>
              <el-tooltip
                placement="top"
                class="black-text"
                style="display: flex; align-items: center"
              >
                <template v-slot:content>
                  <div class="custom-tooltip">
                    The response to HELP keyword may include the Brand name and
                    additional support contact information. ex. Reply HELP to be
                    contacted if you need additional assistance.
                  </div>
                </template>
                <i class="el-icon-info" style="margin-left: 4px" />
              </el-tooltip>
            </div>
          </div>
          <el-form-item class="custom-label" prop="helpMessage">
            <el-input
              v-model="form.helpMessage"
              type="textarea"
              minlength="20"
              maxlength="320"
              :rows="2"
              placeholder="Type Help Message here"
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>

      <campaign-phone-numbers :recordId="recordId"> </campaign-phone-numbers>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import campaignPhoneNumbers from "@/views/pages/10dlc/components/campaign-phone-numbers.vue";
import { apiV2Host } from "@/feathers/feathers-client";
export default {
  name: "CampaignForm",
  components: { campaignPhoneNumbers },
  props: {
    context: { required: true },
    recordId: { default: "" },
    visible: { default: false },
    email: { default: "" },
  },
  data() {
    return {
      campaignSharingStatus: {},
      loading: true,
      optinKeywords: ["START", "YES", "SUBSCRIBE"],
      optoutKeywords: ["STOP"],
      helpKeywords: ["HELP"],
      form: {
        description: "",
        messageFlow: "",
        sample1: "",
        sample2: "",
        sample3: "",
        sample4: "",
        sample5: "",
        optinKeywords: ["START", "YES", "SUBSCRIBE"],
        optinMessage: "",
        optoutKeywords: ["STOP"],
        optoutMessage: "",
        helpKeywords: ["HELP"],
        helpMessage: "",
        usecase: "",
        subUsecases: "",
        status: "",
        registerDate: "",
        renewalDate: "",
        autoRenewal: true,
        termsAndConditions: true,
      },
      copyOfForm: {},
      rules: {
        description: [
          {
            required: true,
            message: "Description is required.",
            trigger: "blur",
          },
          {
            min: 40,
            max: 4096,
            message: "Description must be between 40 and 4096 characters.",
          },
        ],
        messageFlow: [
          {
            required: true,
            message: "Message Flow is required.",
            trigger: "blur",
          },
          {
            min: 40,
            max: 2048,
            message: "Message Flow must be between 40 and 2048 characters.",
          },
        ],
        sample1: [
          {
            required: true,
            message: "At least one sample message is required.",
            trigger: "blur",
          },
          {
            min: 20,
            max: 1024,
            message: "Sample text must be between 20 and 1024 characters.",
          },
        ],
        sample2: [
          {
            min: 20,
            max: 1024,
            message: "Sample text must be between 20 and 1024 characters.",
          },
        ],
        sample3: [
          {
            min: 20,
            max: 1024,
            message: "Sample text must be between 20 and 1024 characters.",
          },
        ],
        sample4: [
          {
            min: 20,
            max: 1024,
            message: "Sample text must be between 20 and 1024 characters.",
          },
        ],
        sample5: [
          {
            min: 20,
            max: 1024,
            message: "Sample text must be between 20 and 1024 characters.",
          },
        ],
        optinKeywords: [
          {
            required: true,
            message: "Opt-In Keywords are required.",
            trigger: "blur",
          },
        ],
        optinMessage: [
          {
            required: true,
            message: "Opt-In Message is required.",
            trigger: "blur",
          },
          {
            min: 20,
            max: 320,
            message: "Opt-In Message must be between 20 and 320 characters.",
          },
        ],
        optoutKeywords: [
          {
            required: true,
            message: "Opt-Out Keywords are required.",
            trigger: "blur",
          },
        ],
        optoutMessage: [
          {
            required: true,
            message: "Opt-Out Message is required.",
            trigger: "blur",
          },
          {
            min: 20,
            max: 320,
            message: "Opt-Out Message must be between 20 and 320 characters.",
          },
        ],
        helpKeywords: [
          { required: true, message: "Help Keywords are required." },
        ],
        helpMessage: [
          {
            required: true,
            message: "Help Message is required.",
            trigger: "blur",
          },
          {
            min: 20,
            max: 320,
            message: "Help Message must be between 20 and 320 characters.",
          },
        ],
      },
      inputFields: [{ key: "sample1" }],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    campaignStatus: function () {
      return (
        this.campaignSharingStatus || {
          downstreamCnpId: null,
          explanation: null,
          sharedDate: null,
          sharingStatus: null,
          statusDate: null,
          upstreamCnpId: null,
        }
      );
    },
  },
  methods: {
    async nudgeCNP() {
      try {
        const response = await fetch(
          `${apiV2Host}/admin/tcr/campaigns/nudge/${this.recordId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
            body: JSON.stringify({ nudgeIntent: "APPEAL_REJECTION" }),
          }
        );

        if (!response.ok) {
          throw new Error("We were unable to load Form data.");
        }

        this.$notify({
          title: "Campaign Nudge",
          message: "Successfully nudged campaign",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          title: "Campaign Nudge",
          message: error,
          type: "error",
        });
      }
    },
    async getCampaignSharingStatus() {
      try {
        const response = await fetch(
          `${apiV2Host}/admin/tcr/campaigns/sharing/${this.recordId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("We were unable to load Form data.");
        }

        const data = await response.json();
        this.campaignSharingStatus = data.sharedByMe;
      } catch (error) {
        this.$notify({
          title: "Campaign Sharing Status",
          message: error,
          type: "error",
        });
      }
    },
    handleSubmit() {
      if (this.context === "Edit") {
        this.handleEdit();
      }
      if (this.context === "Create") {
        this.handleCreate();
      }
    },
    async handleCreate() {
      this.loading = true;
      let data = { ...this.form };
      const { brandId } = this.selectedTenant;
      const postBody = this.removeEmptyFields({
        brandId: brandId,
        description: data.description,
        sample1: data.sample1,
        sample2: data.sample2,
        sample3: data.sample3,
        sample4: data.sample4,
        sample5: data.sample5,
        messageFlow: data.messageFlow,
        helpMessage: data.helpMessage,
        optinKeywords: data.optinKeywords.join().toUpperCase(),
        optoutKeywords: data.optoutKeywords.join().toUpperCase(),
        helpKeywords: data.helpKeywords.join().toUpperCase(),
        optinMessage: data.optinMessage,
        optoutMessage: data.optoutMessage,
        termsAndConditions: data.termsAndConditions,
      });

      try {
        const response = await fetch(`${apiV2Host}/admin/tcr/campaigns`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.state.auth.accessToken,
          },
          body: JSON.stringify(postBody),
        });

        if (!response.ok) {
          const data = await response.json();
          throw new Error(this.formatErrorMessage(data.message));
        }

        this.handleClose();
        this.$notify({
          title: "Uploading Form data",
          message: "Processing your submission!",
          type: "success",
        });
      } catch (error) {
        this.loading = false;
        this.$notify({
          title: "Uploading Form data",
          message: error,
          type: "error",
        });
      }
      this.loading = false;
    },
    removeEmptyFields(obj) {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});
    },
    async handleEdit() {
      this.loading = true;
      const postBody = this.preparePatchData(this.copyOfForm, this.form);
      postBody.optinKeywords = postBody.optinKeywords.length
        ? postBody.optinKeywords.join().toUpperCase()
        : "";
      postBody.optoutKeywords = postBody.optoutKeywords.length
        ? postBody.optoutKeywords.join().toUpperCase()
        : "";
      postBody.helpKeywords = postBody.helpKeywords.length
        ? postBody.helpKeywords.join().toUpperCase()
        : "";

      try {
        const response = await fetch(
          `${apiV2Host}/admin/tcr/campaigns/${this.recordId}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
            body: JSON.stringify(postBody),
          }
        );

        if (!response.ok) {
          const data = await response.json();
          throw new Error(this.formatErrorMessage(data.message));
        }

        this.handleClose();
        this.$notify({
          title: "Uploading Form data",
          message: "Processing your submission!",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          title: "Updating Form data",
          message: error,
          type: "error",
        });
      }
      this.loading = false;
    },
    handleClose() {
      this.$emit("modalClosed");
      this.resetForm();
      this.clearFormFields();
      this.loading = false;
    },
    clearFormFields() {
      this.form.description = "";
      this.form.messageFlow = "";
      this.form.sample1 = "";
      this.form.sample2 = "";
      this.form.sample3 = "";
      this.form.sample4 = "";
      this.form.sample5 = "";
      this.form.optinKeywords = [];
      this.form.optinMessage = "";
      this.form.optoutKeywords = [];
      this.form.optoutMessage = "";
      this.form.helpKeywords = [];
      this.form.helpMessage = "";
      this.form.usecase = "";
      this.form.subUsecases = "";
      this.form.status = "";
      this.inputFields = [{ key: "sample1" }];
      this.campaignSharingStatus = {
        downstreamCnpId: null,
        explanation: null,
        sharedDate: null,
        sharingStatus: null,
        statusDate: null,
        upstreamCnpId: null,
      };
    },
    async populateFields() {
      this.loading = true;
      if (!this.record) {
        this.populateDefaults();
      }
      if (this.recordId) {
        try {
          const response = await fetch(
            `${apiV2Host}/admin/tcr/campaigns/${this.recordId}`,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + this.$store.state.auth.accessToken,
              },
            }
          );

          if (!response.ok) {
            throw new Error("We were unable to load Form data.");
          }

          const data = await response.json();
          if (!data) return;

          this.form.description = data.description || "";
          this.form.messageFlow = data.messageFlow || "";
          this.form.sample1 = data.sample1 || "";
          this.form.sample2 = data.sample2 || "";
          this.form.sample3 = data.sample3 || "";
          this.form.sample4 = data.sample4 || "";
          this.form.sample5 = data.sample5 || "";
          this.form.optinKeywords = data.optinKeywords
            ? data.optinKeywords.split(",")
            : [];
          this.form.optinMessage = data.optinMessage || "";
          this.form.optoutKeywords = data.optoutKeywords
            ? data.optoutKeywords.split(",")
            : [];
          this.form.optoutMessage = data.optoutMessage || "";
          this.form.helpKeywords = data.helpKeywords
            ? data.helpKeywords.split(",")
            : [];
          this.form.helpMessage = data.helpMessage || "";
          this.form.usecase = data.usecase
            ? this.formatString(data.usecase)
            : "";
          this.form.subUsecases = data.subUsecases
            ? data.subUsecases.join(" ")
            : "";
          this.form.status = data.status || "";
          this.form.registerDate = data.createDate
            ? moment(data.createDate).format("M/DD/YY")
            : "";
          this.form.renewalDate = data.nextRenewalOrExpirationDate
            ? moment(data.nextRenewalOrExpirationDate).format("M/DD/YY")
            : "";
          this.form.autoRenewal = data.autoRenewal;
          this.form.termsAndConditions = data.termsAndConditions;

          this.copyOfForm = { ...this.form };

          // Populate inputFields based on the form data
          for (let i = 2; i <= 5; i++) {
            const key = "sample" + i;
            if (this.form[key]) {
              this.inputFields.push({ key });
            }
          }

          // get the campaign sharing status
          await this.getCampaignSharingStatus();
        } catch (error) {
          this.$notify({
            title: "Retrieving Form data",
            message: error,
            type: "error",
          });
        }
      }
      this.loading = false;
    },
    populateDefaults() {
      const { name } = this.selectedTenant;
      this.form.optinMessage = `${name}: Welcome! Msg & data rates may apply. Reply STOP to opt out. Reply HELP for help. Messaging frequency may vary.`;
      this.form.optoutMessage = `${name}: You have opted out of receiving messages from ${name}.`;
      this.form.helpMessage = `${name}: Help at ${this.email}. Msg & data rates may apply. Reply HELP for help. Reply STOP to opt out`;
      this.form.optinKeywords = ["START", "YES", "SUBSCRIBE"];
      this.form.optoutKeywords = ["STOP"];
      this.form.helpKeywords = ["HELP"];
    },
    formatErrorMessage(errorMessage) {
      const fieldName = errorMessage.split("'")[1];
      const formattedFieldName =
        fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
      const characterMap = {
        Description: "40",
        MessageFlow: "40",
        Sample1: "20",
        Sample2: "20",
        Sample3: "20",
        Sample4: "20",
        Sample5: "20",
        OptinMessage: "20",
        OptoutMessage: "20",
        HelpMessage: "20",
        OptinKeywords: "2",
        OptoutKeywords: "2",
        HelpKeywords: "2",
      };

      if (errorMessage.includes("required")) {
        return `Please provide a value for the "${formattedFieldName}" field.`;
      } else if (errorMessage.includes("must contain at least")) {
        const numChars = errorMessage.match(/\d+/)[0];
        return `The "${formattedFieldName}" field must contain at least ${
          characterMap[formattedFieldName]
            ? characterMap[formattedFieldName]
            : "40"
        } character(s).`;
      } else {
        return errorMessage;
      }
    },
    addInputField() {
      if (this.inputFields.length < 5) {
        const key = "sample" + (this.inputFields.length + 1);
        this.inputFields.push({ key });
      }
    },
    resetForm() {
      let formEl = this.$refs.form;
      if (!formEl) return;
      formEl.resetFields();
    },
    formatString(string) {
      return string.replace(/_/g, " ").replace(/\b\w/g, function (match) {
        return match.toUpperCase();
      });
    },
    preparePatchData(originalData, editedData) {
      let patchData = {};
      for (let key in originalData) {
        if (originalData[key]) {
          patchData[key] = editedData[key];
        } else if (!originalData[key] && editedData[key]) {
          patchData[key] = editedData[key];
        }
      }

      return patchData;
    },
    timeFormatter(time) {
      return moment(time).format("M/DD/YY");
    },
  },
};
</script>
<style scoped>
.el-form-item {
  max-width: 600px;
  margin: auto;
}

.container {
  display: flex;
  max-width: 600px;
  height: 15px;
  text-align: right;
  align-items: center;
  justify-content: space-between;
  margin: 30px auto 0;
  font-size: xx-small;
  color: #ffffff;
}

.container-campaign-cards {
  display: flex;
  max-width: 600px;
  align-items: center;
  justify-content: space-between;
  margin: 10px auto 0;
  color: #ffffff;
}

.custom-tooltip {
  max-width: 200px;
  white-space: normal;
  word-wrap: break-word;
}

.el-textarea {
  margin-bottom: 0;
}

::v-deep .custom-label .el-form-item__label {
  color: #ffffff;
}

.page-dashboard {
  overflow: auto;

  .card-base {
    h1 {
      font-weight: 900;
    }

    h2 {
      svg {
        width: 25px;
        height: 25px;
        padding-right: 6px;
      }
    }
  }
}

.widget-info {
  h1,
  h4 {
    margin: 0px;
  }

  h1 {
    font-size: 3em;
  }
}

.nudge {
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding-left: 10px;
  }
}

.nudge-button {
  text-align: center;
  padding: 10px;
}

.system-status {
  display: flex;
  flex-wrap: wrap;

  > * {
    flex-basis: 50%;
  }
}

.system-status-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  padding-bottom: 3px;
  border-bottom: 1px solid lightgray;
}

.widget {
  height: 200px;
  position: relative;

  .widget-header {
    .widget-icon-box {
      background: rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      text-align: center;
      width: 60px;
      padding: 5px;
    }

    .widget-title {
      font-weight: 700;
      border-bottom: 1px solid lightgrey;
    }
  }

  .badge-box {
    .badge {
      display: inline-block;
      border-radius: 4px;
      font-size: 80%;
    }
  }
}

.timeline {
  max-width: 1200px;
  margin: 6px;
}

.timeline,
.timeline-title {
  color: $text-color;
  line-height: 1.4;
  cursor: default;
  font-family: inherit;
}

@media (min-width: 768px) and (max-width: 1040px) {
  .radio-switcher {
    display: none;
  }

  .widget {
    .widget-header {
      .widget-icon-box {
        display: none;
      }
    }
  }
}

@media (max-width: 420px) {
  .radio-switcher {
    display: none;
  }
}
</style>
